var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{staticClass:"chart-wrapper"},[(_vm.chartData)?_c('canvas',{ref:"canvas"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }